import { Component, Vue, Prop } from 'vue-property-decorator'


import { StarRating } from '../StarRating';
import { IDoctor } from '../../models';


const TEMED_HOST = process.env.TEMED_HOST;
const CONSULT_HOST = process.env.CONSULT_HOST;

@Component({
  template: require('./TemedSliderItem.html'),
  components:{
    'star-rating': StarRating
  },
  props:{
    item: Object
  }
})
export class TemedSliderItem extends Vue {

  temedHost: string = TEMED_HOST;
  consultHost: string = CONSULT_HOST;

  @Prop()
  item: IDoctor;

  @Prop()
  onClick: (item) => {}

  // tslint:disable-next-line:no-empty
  mounted () {

  }

  get doctorName(){
    return this.item.prefix+ ' ' + this.item.first_name + '<br />' + this.item.last_name + ' ' + this.item.degree_credentials;
  }

  get avatarUrl(){
    return this.item.avatar.url ? this.consultHost+ this.item.avatar.url : '';
  }

  get itemUrl() {
    return this.temedHost + '/doctors/'+ this.item.slug;
  }

  sliderClick(event){
    event.preventDefault();
    this.onClick(this.item);
  }
}
